import { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import lodashIsEmpty from 'lodash/isEmpty';

import Carousel from '../../../../Components/Carousel';
import constants from '../../../../Config/constants';
import ThemeStyle from '../../../../Theme/styles';

import BannerArrow from './Arrow';
import useExclusiveBannerController from './index.controller';
import Item from './Item';
import Loader from './Loader';
import Pagination from './Pagination';

const ExclusiveBanner = () => {
  const {
    activeSlide,
    carouselHeight,
    carouselRef,
    carouselWidth,
    data,
    isFetching,
    onPressPagination,
    setActiveSlide,
  } = useExclusiveBannerController();

  const renderItem = useCallback(
    (props) => <Item {...props} isVisible={props.index === activeSlide} />,
    [activeSlide],
  );

  if (isFetching) {
    return <Loader height={carouselHeight} width={carouselWidth} />;
  } else if (lodashIsEmpty(data)) {
    return <View style={ThemeStyle.spacingTop} />;
  }

  return (
    <View style={ThemeStyle.pageVerticalSpacing}>
      <BannerArrow
        disablePrev={activeSlide === 0}
        disableNext={activeSlide === data.length - 1}
        onNext={() => onPressPagination(activeSlide + 1)}
        onPrev={() => onPressPagination(activeSlide - 1)}
      >
        {/* @ts-ignore: children error typescript */}
        <Carousel
          ref={carouselRef}
          autoPlayInterval={5000}
          data={data}
          height={carouselHeight}
          enabled={!constants.isWeb}
          // activeOffsetX for mobile: gesture don’t activate unless dragging left/right more than 10px
          panGestureHandlerProps={{
            activeOffsetX: [-10, 10],
            failOffsetY: [-10, 10],
          }}
          style={styles.containerOffset}
          width={carouselWidth}
          onSnapToItem={setActiveSlide}
          renderItem={renderItem}
          autoPlay
        >
          <Pagination
            activeIndex={activeSlide}
            count={data.length}
            onPress={onPressPagination}
          />
        </Carousel>
      </BannerArrow>
    </View>
  );
};

const styles = StyleSheet.create({
  containerOffset: {
    marginHorizontal: -5,
  },
});

export default ExclusiveBanner;
